import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const CYCLE_EVENTS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('CYCLE_EVENTS');
export const CYCLE_EVENTS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	CYCLE_EVENTS_CRUD_ACTION_CONSTANTS
);
